// Tab logic for pdp-sellers section

document.addEventListener("DOMContentLoaded", function () {
  const tabList = document.querySelector(".pdp-sellers__tab-list");
  if (!tabList) return;
  const tabs = Array.from(tabList.querySelectorAll(".pdp-sellers__item-title"));
  const panels = Array.from(
    document.querySelectorAll('.pdp-sellers__item[role="tabpanel"]')
  );

  function activateTab(idx) {
    tabs.forEach((tab, i) => {
      const selected = i === idx;
      tab.setAttribute("aria-selected", selected);
      tab.setAttribute("tabindex", selected ? "0" : "-1");
      if (selected) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
    panels.forEach((panel, i) => {
      if (i === idx) {
        panel.style.display = "block";
        panel.removeAttribute("hidden");
      } else {
        panel.style.display = "none";
        panel.setAttribute("hidden", "");
      }
    });
    // Re-init product swipers in case of dynamic content
    setTimeout(initOrDestroyProductSwipers, 10);
  }

  tabs.forEach((tab, idx) => {
    tab.addEventListener("click", function () {
      activateTab(idx);
    });
    tab.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        activateTab((idx + 1) % tabs.length);
        tabs[(idx + 1) % tabs.length].focus();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        activateTab((idx - 1 + tabs.length) % tabs.length);
        tabs[(idx - 1 + tabs.length) % tabs.length].focus();
      }
    });
    // Make divs focusable for accessibility
    tab.setAttribute("tabindex", tab.getAttribute("tabindex") || "0");
    tab.setAttribute("role", "tab");
  });
});

// Responsive Swiper for each .pdp-sellers__products
function initOrDestroyProductSwipers() {
  const isMobile = window.innerWidth < 1024;
  document.querySelectorAll(".pdp-sellers__products").forEach(function (el) {
    // Remove any previous Swiper instance
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
    if (isMobile) {
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        allowTouchMove: true,
        speed: 400,
        navigation: {
          nextEl: el.parentElement.querySelector(".swiper-next"),
          prevEl: el.parentElement.querySelector(".swiper-prev"),
        },
        pagination: {
          el: el.parentElement.querySelector(".swiper-dots"),
          clickable: true,
        },
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Init on load
  initOrDestroyProductSwipers();
  // Re-init on resize
  window.addEventListener("resize", function () {
    clearTimeout(window.__pdpSellersResizeTimeout);
    window.__pdpSellersResizeTimeout = setTimeout(
      initOrDestroyProductSwipers,
      150
    );
  });
});
